import script from "./InsuranceComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceComponent.vue?vue&type=style&index=0&id=3a0c59fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0c59fe"]])

export default __exports__